export default {
    indexPaymentEvents:     { method: 'get',    url: 'payment_events' },
    createPaymentEvent:     { method: 'post',   url: 'payment_events'},
    updatePaymentEvent:     { method: 'put',    url: 'payment_events/{id}'},
    destroyPaymentEvent:    { method: 'delete', url: 'payment_events/{id}'},
    indexNatures:           { method: 'get',    url: 'payment_events/natures' },
}